import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Button from '@components/button/Button'
import Modal from '@components/modal/Modal'
import SimpleAlert from '@components/modal/SimpleAlert'
import SortByAlert from '@components/modal/SortByAlert'

const sortBy = [
  { label: 'Choice 1', value: 'choice1' },
  { label: 'Choice 2', value: 'choice2' },
  { label: 'Choice 3', value: 'choice3' },
]

const ModalsSection = () => {
  const [sort, setSort] = React.useState(sortBy[0])
  return (
    <Section>
      <SectionTitle>Modals</SectionTitle>
      <Container>
        <Button
          status="active"
          label="Open Modal"
          onClick={() =>
            Modal.open({
              Content: () => (
                <ModalContent>
                  <Label>Modal is opened</Label>
                </ModalContent>
              ),
            })
          }
        />
      </Container>
      <Container>
        <Button
          status="active"
          label="Open Simple Alert"
          onClick={() =>
            SimpleAlert.open({
              title: 'Alert Title',
              description: 'Alert description here',
              buttons: [
                { label: 'First', onClick: () => SimpleAlert.close() },
                { label: 'Second', onClick: () => SimpleAlert.close(), color: 'light' },
              ],
            })
          }
        />
      </Container>
      <Container>
        <Button
          status="active"
          label="Open SortBy"
          onClick={() => SortByAlert.open({ data: sortBy, initValue: sort, onChange: (opt) => setSort(opt as any) })}
        />
      </Container>
    </Section>
  )
}

export default ModalsSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const ModalContent = styled(View)`
  width: 300px;
  height: 150px;
  background-color: ${(props) => props.theme.colors.background};
  justify-content: center;
  align-items: center;
`
const Label = styled(Text)`
  ${(props) => props.theme.fonts.Callout};
`
const Container = styled(View)`
  margin: 8px 0;
`
